var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"id":"app"}},[_c('Navigation'),_c('Masthead'),_c('Products'),_c('ProductsGrid'),_c('Contact'),_c('Footer'),_vm._l((_vm.Products),function(product){return _c('ProductsModal',{key:product.Name,attrs:{"product":product}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }